<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Popover, Toggle, Text, IconButton, Input } from '@Shelly/shelly-design-system';
	//Types
	import PinUnlock from 'src/components/PinUnlock.svelte';
	import { user_data } from 'src/stores/account/user';
	const dispatch = createEventDispatcher();

	export let alarm_object = {};
	let checked = alarm_object?.pin_lock || false;
	let initialChecked = checked;
	let pinLocked = alarm_object?.pin_lock || false,
		showModal = false;

	let showPinLockPopover = false;
	let pinValue = $user_data.lock_pin;

	function handleClose(e) {
		showModal = false;
		checked = initialChecked;
		dispatch('checked', checked);
	}

	function handleUnlock() {
		dispatch('checked', checked);
	}
</script>

<div class="d-flex align-items-end">
	<Toggle
		id="toggle-pin-lock"
		class="mt-s"
		{checked}
		size="m"
		on:click={() => {
			checked = !checked;
			// if device is unlocked, there is no need to showing password modal
			// if device is locked, then we showing the pass modal
			if (pinLocked && !checked) {
				showModal = true;
			} else {
				dispatch('checked', checked);
			}
		}}
	>
		{$format('enable', {
			default: 'Enable',
		})}
		{$format('sub_settings_title_pin_lock', {
			default: 'pin lock',
		})}
	</Toggle>
	<Popover
		class="mr-m ml-s"
		show={showPinLockPopover}
		placement="top"
		hideCloseBtn={true}
		on:close={() => (showPinLockPopover = false)}
	>
		<IconButton
			aria-label={$format('pin_lock_info', { default: 'Pin lock information' })}
			icon="fa-solid fa-circle-info"
			variant="help"
			class="text-primary"
			on:click={() => {
				showPinLockPopover = !showPinLockPopover;
			}}
			size="s"
		/>
		<svelte:fragment slot="customContent">
			<Text class="mb-m" styleType="body-small"
				>{$format('will_use_default_pin_lock', {
					default: "This will use the default app 'pin lock' which you can check out below.",
				})}</Text
			>
			<Input
				id="input-pin-lock"
				aria-label={$format('pin_lock_pass', { default: 'Pin lock password' })}
				class="mb-s"
				icon={'fas fa-key'}
				value={pinValue}
				type={'password'}
				readonly={true}
			/>
			<Text styleType="body-small"
				>{$format('can_change_pin_lock_from_settings', {
					default: "You can always change it by going to the 'App settings' section.",
				})}</Text
			>
		</svelte:fragment>
	</Popover>
</div>

{#if showModal}
	<PinUnlock
		bind:showModal
		on:close={handleClose}
		on:unlock={handleUnlock}
		on:cancel={() => (showModal = false)}
	/>
{/if}
